var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ItemPath",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ItemPath-Reports-Copy",
    transform: "translate(-393.000000, -249.000000)",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.352322,255.311645 L413.934803,252.340841 L410.449166,252.830715 L410.449166,250 L407.449166,250 L407.449166,253.252338 L401.449166,254.095583 L401.449166,250 L398.449166,250 L398.449166,254.517205 L394.129441,255.124303 L394.54696,258.095107 L398.449166,257.546688 L398.449166,264.136894 L394.765327,264.654624 L395.182846,267.625428 L398.449166,267.166377 L398.449166,270 L401.449166,270 L401.449166,266.744755 L407.449166,265.90151 L407.449166,270 L410.449166,270 L410.449166,265.479887 L414.988208,264.841966 L414.570689,261.871162 L410.449166,262.450404 L410.449166,255.860198 L414.352322,255.311645 Z M407.449166,256.28182 L407.449166,262.872027 L401.449166,263.715272 L401.449166,257.125065 L407.449166,256.28182 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon);
export default __webpack_public_path__ + "static/media/numberIcon.cdc39ef2b0692576f7fa9fc793c31c0a.svg";
export { ForwardRef as ReactComponent };